export const NEGATIVE_RATING_THRESHOLD = 2

export const DELIVEROO_ORDER_URL_PREFIX: string = 'https://partner-hub.deliveroo.com/orders'
export const UBEREATS_ORDER_URL_PREFIX: string = 'https://merchants.ubereats.com/manager/orders'

export const REPLY_DEADLINE_DAYS: Record<string, number> = { ubereats: 14, deliveroo: 60 }

export type StoreOption = { id: number; name: string }

export interface DeliveryReviewOrderItem {
  name: string
  quantity: number
  price: number
}

export interface DeliveryReviewOrder {
  orderUuid: string
  platformSlug: 'deliveroo' | 'ubereats'
  orderTotal: number | null
  currencyCode: string | null
  deliveredAt: string | null
  items: DeliveryReviewOrderItem[] | null
}

export interface DeliveryReview {
  id: number
  date: string
  text: string | null
  rating: number
  name: string | null
  ownerResponseText: string | null
  compensationAmount: number | null
  order: DeliveryReviewOrder | null
  sourceUrl: string | null
  platformSlug?: 'deliveroo' | 'ubereats'
  store: { id: number; name: string }
  storeReviewPlatform?: {
    platform?: {
      slug: 'deliveroo' | 'ubereats'
    }
  }
  reviewManager?: {
    hasReplyFeature: boolean
  }
}

export interface ReviewStatsSummary {
  total: number
  averageRating: number
  unrepliedCount: number
  negativeCount: number
}

export interface ReviewPlatformsFilters {
  platformSlugs: ('deliveroo' | 'ubereats')[]
  storeIds: number[]
  fromDate: string | null
  toDate: string | null
  notes: number[]
}

export interface DeliverooBranch {
  branchId: string
  orgId: string
  name: string
  city: string | null
  customerFacingLink: string | null
}

export interface PlatformStoresConfig {
  isConfigured: boolean
  stores: { storeId: number; externalStoreId: string }[]
}

export interface MerchantReviewManagerConfig {
  deliveroo: PlatformStoresConfig
  ubereats: PlatformStoresConfig
}
